import { z } from 'zod';
const NullableString = z.string().nullable();
const NullableNumber = z.number().nullable();
const BqTemporal = z
    .union([z.string(), z.object({ value: z.string() })])
    .transform((v) => (typeof v === 'string' ? v : v.value))
    .nullable();
export const PlanningCase = z.object({
    case_id: z.string(),
    source_id: z.string(),
    source_case_number: z.string(),
    case_family: NullableString,
    case_type: NullableString,
    title: NullableString,
    description: NullableString,
    applicant_name: NullableString,
    applicant_type: NullableString,
    status: NullableString,
    status_normalized: NullableString,
    submitted_date: BqTemporal,
    decision_date: BqTemporal,
    closed_date: BqTemporal,
    address_line1: NullableString,
    city: NullableString,
    state: NullableString,
    postal_code: NullableString,
    latitude: NullableNumber,
    longitude: NullableNumber,
    jurisdiction_name: NullableString,
    place_geoid: NullableString,
    county_fips: NullableString,
    proposed_use: NullableString,
    existing_zoning: NullableString,
    proposed_zoning: NullableString,
    decision_body: NullableString,
    legislative_id: NullableString,
    raw_uri: NullableString,
    request_hash: NullableString,
    manifest_sha: NullableString,
    mapper_version: NullableString,
    fetched_at: BqTemporal,
    mapped_at: BqTemporal,
});
export const PlanningAction = z.object({
    action_id: z.string(),
    action_type: NullableString,
    action_text: NullableString,
    disposition: NullableString,
});
export const PlanningParcel = z.object({
    case_parcel_id: z.string(),
    parcel_number: NullableString,
    bbl: NullableString,
    address_line1: NullableString,
});
export const PlanningEvent = z.object({
    event_id: z.string(),
    event_type: NullableString,
    event_date: BqTemporal,
    body: NullableString,
    outcome: NullableString,
});
export const PlanningPermitLink = z.object({
    link_id: z.string(),
    permit_id: z.string(),
    permit_source_id: z.string(),
    permit_date: BqTemporal,
    source_permit_number: NullableString,
    permit_type: NullableString,
    permit_address: NullableString,
    match_method: z.string(),
    match_tier: z.number().int().nullable(),
    match_kind: NullableString,
    match_confidence: z.number(),
    candidate_count: z.number().int(),
    is_ambiguous: z.boolean().nullable(),
    valid_on_case_window: z.boolean().nullable(),
    temporal_basis: NullableString,
});
export const PlanningContractorLink = z.object({
    link_id: z.string(),
    entity_id: NullableString,
    credential_id: NullableString,
    authority_id: NullableString,
    match_method: z.string(),
    match_tier: z.number().int().nullable(),
    match_confidence: z.number(),
    candidate_count: z.number().int(),
    is_ambiguous: z.boolean().nullable(),
    valid_on_activity_date: z.boolean().nullable(),
    temporal_basis: NullableString,
    display_name: NullableString.optional(),
    license_number: NullableString.optional(),
    credential_class_description: NullableString.optional(),
});
export const PlanningSearchResponse = z.object({ cases: z.array(PlanningCase) });
export const PlanningDetailResponse = z.object({
    case: PlanningCase,
    actions: z.array(PlanningAction),
    parcels: z.array(PlanningParcel),
    events: z.array(PlanningEvent),
    permits: z.array(PlanningPermitLink),
    contractors: z.array(PlanningContractorLink),
});
//# sourceMappingURL=planning.js.map